"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartBar = void 0;
var react_1 = __importDefault(require("react"));
var utils_1 = require("../utils");
var ChartBar_styled_1 = require("./ChartBar.styled");
/**
 * A Bar in the chart, which may be split into multiple "Segments".
 */
var ChartBar = function (_a) {
    var bar = _a.bar, scale = _a.scale, legend = _a.legend, barWidth = _a.barWidth, rest = __rest(_a, ["bar", "scale", "legend", "barWidth"]);
    var barTotal = (0, utils_1.getBarTotal)(bar);
    return bar.segments.length ? (react_1.default.createElement(ChartBar_styled_1.StyledBar, __assign({ "aria-hidden": "true", size: (0, utils_1.getSize)(barTotal, scale), barWidth: barWidth }, rest), bar.segments.map(function (_a, key) {
        var value = _a.value, type = _a.type;
        var color = (0, utils_1.getLegendData)(legend, type).color;
        return value ? (react_1.default.createElement(ChartBar_styled_1.StyledSegment, { key: "segment-".concat(key), "data-testid": "chart-segment", size: (0, utils_1.getSize)(value, barTotal), color: color })) : null;
    }))) : (react_1.default.createElement(ChartBar_styled_1.StyledSpaceBar, { size: "0", barWidth: barWidth }));
};
exports.ChartBar = ChartBar;
